var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import { Grid } from '@arco-design/web-react';
import cs from 'classnames';
import './style/col.less';
var GridItemRender = function (props, ref) {
    var className = props.className, restProps = __rest(props, ["className"]);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-grid-item");
    return (React.createElement(Grid.GridItem, __assign({ "data-tid": "m4b_grid_grid_item" }, restProps, { ref: ref, className: cs("".concat(prefixCls), className) })));
};
var GridItem = forwardRef(GridItemRender);
GridItem.displayName = 'GridItem';
GridItem.__ARCO_GRID_ITEM__ = true;
export default GridItem;
